import React, { useState } from "react";
import { Card, CardContent, Typography, CardMedia } from "@mui/material";
import { Animal } from "src/services/types";
import { FaHorse } from "react-icons/fa";
import AnimalDialog from "./AnimalDialog";

const AnimalCard: React.FC<{ animal: Animal }> = ({ animal }) => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Card onClick={handleOpenDialog} sx={{ cursor: "pointer" }}>
      <CardContent>
        <CardMedia
          component="img"
          height="140"
          image={animal.photos?.[0] || "https://via.placeholder.com/150"}
          alt={animal.name}
        />
        <Typography variant="h5" component="div">
          {animal.name}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {animal.specie === "cattle" && <FaHorse style={{ marginRight: 8 }} />}
          {animal.specie === "sheep" && <FaHorse style={{ marginRight: 8 }} />}
          {animal.specie === "donkey" && <FaHorse style={{ marginRight: 8 }} />}
          {animal.specie}
        </Typography>
        <Typography variant="body2">Edad: {animal.age} años</Typography>
        {animal.description && (
          <Typography variant="body2" sx={{ mt: 1 }}>
            {animal.description}
          </Typography>
        )}
      </CardContent>
      <AnimalDialog
        open={openDialog}
        onClose={handleCloseDialog}
        animal={animal}
      />
    </Card>
  );
};

export default AnimalCard;
